import React from "react";
import {
  FaCogs,
  FaSlidersH,
  FaBalanceScale,
  FaClock,
  FaGlobe,
  FaChartLine,
} from "react-icons/fa";

function AdvancedATrading() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Key Features of Our Crypto Market Making Services
                </h2>
              </div>
              <div className="col-lg-5 offset-lg-1">
                <p>
                  Explore our advanced, data-driven solutions designed to
                  enhance liquidity, stabilize prices, and optimize trading
                  performance across multiple exchanges, ensuring seamless
                  market operations for your digital assets.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaCogs size={42} />
                  </div>
                  <h4>Advanced Algorithmic Trading</h4>
                  <p>
                    Utilizing sophisticated algorithms to provide consistent
                    liquidity and maintain tight bid-ask spreads across multiple
                    exchanges.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaSlidersH size={42} />
                  </div>
                  <h4>Customizable Liquidity Strategies</h4>
                  <p>
                    Tailored solutions to meet the unique liquidity needs of
                    each token or platform, ensuring optimal trading
                    performance.
                  </p>
                  <br />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaBalanceScale size={42} />
                  </div>
                  <h4>Price Stability</h4>
                  <p>
                    Active order placement minimizes volatility, creating a more
                    stable trading environment for both new and existing tokens.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaClock size={42} />
                  </div>
                  <h4>24/7 Market Monitoring</h4>
                  <p>
                    Around-the-clock monitoring and adjustments to keep
                    liquidity flowing smoothly, even during off-peak trading
                    hours.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaGlobe size={42} />
                  </div>
                  <h4>Multi-Exchange Support</h4>
                  <p>
                    Providing liquidity across a wide range of cryptocurrency
                    exchanges, ensuring broad market coverage and accessibility.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaChartLine size={42} />
                  </div>
                  <h4>Data-Driven Optimization</h4>
                  <p>
                    Leveraging real-time data analytics to continuously refine
                    strategies, improving market efficiency and trading
                    outcomes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdvancedATrading;
